module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var ctypeName = [
    'fixme 0', 'Database', 'Directory Service', 'SOAP Web Service',
    'App', 'fixme 5', 'fixme 6', 'Text File', 'fixme 8', 'Google Sheets', 'fixme 10', 'REST Web Service Connection',
    'Vector Database'
];

    ; __append("\r\n<div class=\"col-md-12\" style=\"padding:0;\">\r\n        <h2 style=\"margin: 10px 0 5px 0;\">General</h2>\r\n        <div class=\"row\">\r\n            <div class=\"col-sm-3\">\r\n                <span>Name</span>\r\n            </div>\r\n            <div class=\"col-sm-9\">\r\n                <input type=\"text\" name=\"Name\" value=\"")
    ; __append(escapeFn( currentConnectionDetails.Name ))
    ; __append("\" maxlength=\"50\" />\r\n            </div>\r\n        </div>\r\n        <div class=\"row\">\r\n            <div class=\"col-sm-3\" style=\"margin-top:3px;\">\r\n                <span>Type</span>\r\n            </div>\r\n            <div class=\"col-sm-9\" style=\"height:30px\">\r\n                    <div style=\"float:left;margin-right: 10px;margin-top: 3px;\">\r\n                        <span>")
    ; __append(escapeFn( ctypeName[currentConnectionDetails.Type] ))
    ; __append("</span>\r\n                    </div>\r\n                    <div style=\"float: left; margin-right: 5px;\">\r\n                        <input type=\"checkbox\" name=\"IsActive\" ")
    ; __append(escapeFn(currentConnectionDetails.IsActive==='True' ? " checked" : "" ))
    ; __append(" />\r\n                    </div>\r\n                    <div class=\"middle-align\">\r\n                       <span>Active</span>\r\n                    </div>\r\n                \r\n            </div>\r\n        </div>\r\n</div>")
  }
  return __output;

}